import { render, staticRenderFns } from "./AboutUs.vue?vue&type=template&id=1ecb9a00&scoped=true"
import script from "./AboutUs.vue?vue&type=script&lang=js"
export * from "./AboutUs.vue?vue&type=script&lang=js"
import style0 from "./AboutUs.vue?vue&type=style&index=0&id=1ecb9a00&prod&lang=less"
import style1 from "./AboutUs.vue?vue&type=style&index=1&id=1ecb9a00&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ecb9a00",
  null
  
)

export default component.exports